// extracted by mini-css-extract-plugin
export default {"root":"TextArea__root--qb+AKn","container":"TextArea__container--uzWrsd","textarea":"TextArea__textarea--wFx0Qs"};